'use client'

import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from './toast'
import { useToast } from './use-toast'

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider duration={2000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
          >
            <div className="relative grid gap-1">
              {props.variant === 'loading' ? (
                <>
                  <div className="flex items-center justify-center gap-5">
                    <div className="loader" />
                    {title && <ToastTitle>{title}</ToastTitle>}
                  </div>
                  {description && <ToastDescription>{description}</ToastDescription>}
                </>
              ) : (
                <>
                  {title && <ToastTitle>{title}</ToastTitle>}
                  {description && <ToastDescription>{description}</ToastDescription>}
                </>
              )}

              {/* <p>!!!!!!!!!!!!!!!!!!</p> */}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
